import styled from 'styled-components';

export const AboutDescription = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const AboutSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ActionArea = styled('div')`
  display: flex;
  gap: 10px;
`;

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 30px 0;
`;

export const InstructionRow = styled('div')`
  align-items: center;
  display: flex;
  gap: 10px;

  svg {
    height: 30px;
    min-width: 30px;
    width: 30px;
  }
`;

export const InstructionSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
